module.exports = __webpack_public_path__ + "static/media/b19.5165c177.svg";